import { Button, Section } from '@pkdigital/pkd-custom-components';
import useMediaQuery from '@restart/hooks/useMediaQuery';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TrackerUtil } from '../../tracking/TrackerUtil';
import { md, minBreakpoints } from '../../utils/media-queries';
import { useBranding } from '../../hooks/useBranding';

const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
  // Tracking
  TrackerUtil.trackBtnClick(
    `td-home_button_${'technical-clarification cta'.split('-')[0]}`,
    `button_${'technical-clarification-cta'.split('-')[0]}`
  );

  e.preventDefault();
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.append('alt_home', 'true');
  window.location.href = `/onboarding?${urlParams.toString()}`;
};

const SectionHeader = ({ title }) => {
  const isMdOrAbove = useMediaQuery(`(min-width: ${minBreakpoints.md}px)`);
  return isMdOrAbove ? <h2>{title}</h2> : <h4>{title}</h4>;
};

export const TechnicalClarification = () => {
  const { t } = useTranslation();
  const branding = useBranding();

  return (
    <Section className="technical-clarification">
      <Container>
        <Row className="align-items-center">
          <Col className="pe-0 welcome-service-img-wrapper">
            <picture>
              <source
                media={`(${md})`}
                srcSet={'/td-home/images/landingpage/landingpage-welcome-service-agent-min.png'}
              />
              <img
                id={'welcome-service-img'}
                src={'/td-home/images/landingpage/landingpage-welcome-service-agent-min-sm.png'}
                alt={'Bild von Welcomeservice Mitarbeiter'}
              />
            </picture>
          </Col>
          <Col className="welcome-service-content-wrapper">
            <SectionHeader
              title={
                t('technicalClarificationSection.imageCard.title1') +
                ' ' +
                t('technicalClarificationSection.imageCard.title2')
              }
            />

            <ul>
              <li className={branding === 'hug' ? 'li-blue' : ''}>
                {' '}
                {t('technicalClarificationSection.bulletPoints.bp1')}
              </li>
              <li className={branding === 'hug' ? 'li-blue' : ''}>
                {' '}
                {t('technicalClarificationSection.bulletPoints.bp2')}
              </li>
            </ul>

            <Button onClick={onClick}>{t('technicalClarificationSection.button')}</Button>
          </Col>
        </Row>
      </Container>
    </Section>
  );
};
